/* eslint-disable camelcase*/
import { fromJS, Map } from 'immutable';
import { createStructuredSelector } from 'reselect';
import { StatusCodes } from 'http-status-codes';

import logger from 'logger';
import ApiException from 'services/ApiService/ApiException';
import parseCatch from 'utils/parseCatch';
import ApiService from 'services/ApiService/ApiService';

import makeAction from '../../../../utils/makeAction';

import Api, { GET_PERFORMER_VIDEOS } from './Api';


const ADD_PENDING_VIDEO = 'cam4/profile/ADD_PENDING_VIDEO';
const SET_LIBRARY_VIDEOS = 'cam4/profile/SET_LIBRARY_VIDEOS';
const SET_PENDING_VIDEOS = 'cam4/profile/SET_PENDING_VIDEOS';
const SET_SHOP_VIDEOS = 'cam4/profile/SET_SHOP_VIDEOS';

const initialState = fromJS({
  libraryVideos: fromJS({}),
  shopVideos: Map(),
  totalCountShopVideos: 0,
  pendingVideos: Map(),
  totalCountPendingVideos: 0,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SHOP_VIDEOS:
      return state.set('shopVideos', fromJS(action.shopVideos)).set('totalCountShopVideos', action.totalCount);

    case SET_PENDING_VIDEOS:
      return state.set('pendingVideos', fromJS(action.pendingVideos)).set('totalCountPendingVideos', action.totalCount);

    case SET_LIBRARY_VIDEOS:
      return state.set('libraryVideos', fromJS(action.libraryVideos));

    case ADD_PENDING_VIDEO:
      return state.update('pendingVideos', (list) => list.push(action.video));

    default:
      return state;
  }
}

export const NAME = 'performerShop';

// Input Selectors
const shopVideos = (state) => state[NAME].get('shopVideos');
const totalCountShopVideos = (state) => state[NAME].get('totalCountShopVideos');
const pendingVideos = (state) => state[NAME].get('pendingVideos');
const totalCountPendingVideos = (state) => state[NAME].get('totalCountPendingVideos');
const libraryVideos = (state) => state[NAME].get('libraryVideos');

/**
 * Actions
 */
const setShopVideos = makeAction(SET_SHOP_VIDEOS, 'shopVideos', 'totalCount');
const setPendingVideos = makeAction(SET_PENDING_VIDEOS, 'pendingVideos', 'totalCount');
const setLibraryVideos = makeAction(SET_LIBRARY_VIDEOS, 'libraryVideos');
const setPendingVideo = makeAction(ADD_PENDING_VIDEO, 'video');

/**
 * API
 */
/**
 *
 * @param username
 * @param limit
 * @param status
 * @returns {Promise}
 */
async function getVideosByStatus(username, limit, status) {
  const params = {
    userName: username,
    sortBy: 'priority',
  };

  if (status) {
    params.status = status;
  }

  if (limit) {
    params.limit = limit;
  }

  let result = undefined;
  try {
    result = await ApiService.get(GET_PERFORMER_VIDEOS, { params });
  } catch (err) {
    if (err instanceof ApiException) {
      logger.warn(err.message);
    }
  }

  return result;
}

function getPendingVideos(username, limit) {
  return async(dispatch) => {
    const response = await getVideosByStatus(username, limit, 'PENDING_APPROVAL');
    const data = response.data === '' ? [] : response.data;
    const totalCount = response.headers && response.headers.totalcount;

    return dispatch(setPendingVideos(data, totalCount * 1 || 0));
  };
}

function addPendingVideo(video) {
  return (dispatch) => dispatch(setPendingVideo(video));
}

function getLibraryVideos(username, filterValue) {
  const params = { sortBy: 'date' };

  if (filterValue) {
    params.performer = filterValue;
  }

  return async(dispatch) => {
    let result = undefined;
    try {
      const url = ApiService.substitute(Api.LIBRARY_VIDEOS_URL, { username });
      const response = await ApiService.get(url, { params });

      if (response.status === StatusCodes.OK || response.status === StatusCodes.NO_CONTENT) {
        result = dispatch(setLibraryVideos(response.data));
      }
    } catch (err) {
      /**
       * We have access to custom error context
       */
      if (err instanceof ApiException) {
        logger.warn({ msg: err.message, url: err.url, status: err.status });
        parseCatch(err);
      }
    }

    return result;
  };
}

/**
 *
 * @param username
 * @param limit
 * @returns {*}
 */
function getShopVideos(username, limit) {
  return async(dispatch) => {
    const response = await getVideosByStatus(username, limit, 'APPROVED');
    const data = response.data === '' ? [] : response.data;
    const totalCount = response.headers && response.headers.totalcount;

    return dispatch(setShopVideos(data, totalCount * 1 || 0));
  };
}

export const selector = createStructuredSelector({
  libraryVideos,
  pendingVideos,
  shopVideos,
  totalCountPendingVideos,
  totalCountShopVideos,
});

export const actionCreators = {
  getShopVideos,
  getPendingVideos,
  getLibraryVideos,
  addPendingVideo,
};
